import {Stack} from 'platform/foundation';

interface Props {
  children: React.ReactNode;
  isFullWidth?: boolean;
}

export function ActionItemWrapper(props: Props) {
  if (!props.isFullWidth) {
    return props.children;
  }

  return (
    <Stack direction="row" grow={1} basis={0}>
      {props.children}
    </Stack>
  );
}
